"use client";
import { defaultLocale } from "@/config";
import { Tabs } from "antd";
import { StyledArticle } from "../Blogs/BlogArticle";
import { useTranslations } from "next-intl";
import { useState } from "react";
const ProductDescription = ({ product, locale }) => {
	const t = useTranslations();
	const [activeKey, setActiveKey] = useState<string>("1");

	return (
		<div className="pdes ">
			<Tabs
				type="card"
				className=" !font-abeezee"
				onChange={(key) => setActiveKey(key)}
				defaultActiveKey={activeKey || "1"}
				items={[
					{
						label: (
							<div
								className={`font-abeezee ${
									activeKey == "1" ? "bg-[#253333] text-white" : "bg-white text-black"
								} flex h-[50px] items-center justify-center gap-4 rounded-full  px-4 text-[22px] font-normal`}
							>
								<span className="flex h-[40px] w-[40px] items-center justify-center rounded-full bg-white">
									<img src="/image/miaoshu.svg" className="h-[26px] w-[26px]" alt="description" />
								</span>
								<p className="">{t("product.description")}</p>
							</div>
						),
						key: "1",
						children: (
							<StyledArticle>
								<div
									className="p-4"
									dangerouslySetInnerHTML={{
										__html:
											locale == defaultLocale
												? filterSortDsc(product.descriptionJson).longDsc
												: filterSortDsc(product.translation.descriptionJson).longDsc ||
													filterSortDsc(product.descriptionJson).longDsc,
									}}
								/>
							</StyledArticle>
						),
					},
					{
						label: (
							<div
								className={`font-abeezee ${
									activeKey == "2" ? "bg-[#253333] text-white" : "bg-white text-black"
								} flex h-[50px]  items-center justify-center gap-4 rounded-full  px-4 text-[22px] font-normal`}
							>
								<span className="flex h-[40px] w-[40px] items-center justify-center rounded-full bg-white">
									<img src="/image/shipping.svg" className="h-[26px] w-[26px]" alt="description" />
								</span>
								<p className="">{t("common.shippingInfo")}</p>
							</div>
						),
						key: "2",
						children: (
							<StyledArticle>
								<div className="!font-abeezee p-4 leading-[30px]">
									<h2>{t("common.Shipping")}</h2>
									<p>{t("common.s1")}</p>
									<p>{t("common.s2")}</p>
									<p>{t("common.s3")}</p>
								</div>
							</StyledArticle>
						),
					},
				]}
			/>
			<style
				dangerouslySetInnerHTML={{
					__html: `
					.product_desc .ant-tabs-tab-btn {
						color: #000 !important;
					}
		`,
				}}
			></style>
		</div>
	);
};

export default ProductDescription;

type dscList = {
	blocks: dscObj[];
};
type dscObj = {
	data: { text: string };
	type: string;
};
const filterSortDsc = (dsc: string) => {
	const dscObj = JSON.parse(dsc) as dscList;
	let sortDsc = "";
	let longDsc = "";
	if (dscObj && dscObj.blocks.length > 0) {
		sortDsc = dscObj.blocks[1].data.text;
		longDsc = handlerInnerHtml(dscObj.blocks[0].data.text);
	}
	return { sortDsc, longDsc };
};

const handlerInnerHtml = (html: string): string => {
	if (!html) return html;
	return html
		.replace(/&lt;/g, "<")
		.replace(/&gt;/g, ">")
		.replace(/&amp;/g, "&")
		.replace(/&quot;/g, '"')
		.replace(/&#8216;/g, "‘")
		.replace(/&#8217;/g, "’")
		.replace(/&#8211;/g, "–")
		.replace(/&nbsp;/g, " ");
};
